import { actionsPreprocessor } from '../../utils/redux';

const actionNames = [
  'FETCH_LEADS',
  'FETCH_SUCCESS',
  'FETCH_FAILED',

  'FETCH_LEADS_SUMMARY',
  'FETCH_SUMMARY_SUCCESS',
  'FETCH_SUMMARY_FAILED',

  'CHANGE_TAB',

  'TABLE_CHANGE',
];

const { actions, actionTypes } = actionsPreprocessor('leads', actionNames);

export default actions;
export { actionTypes };
